export default function not(func) {
    return function (value) {
        return !func(value);
    };
}
